import { makeAutoObservable } from 'mobx';
import { FilterCondition } from 'shared/types/flowstep';

export class FilterManagerState {
  conditions: FilterCondition[] = [];

  constructor(conditions: FilterCondition[]) {
    makeAutoObservable(this);

    this.conditions = conditions.map((condition) => ({ ...condition }));
  }

  addCondition() {
    this.conditions.push({
      fieldName: '',
      value: '',
      operator: '',
      joinOperator: 'AND',
      type: '',
    });
  }

  deleteCondition(index: number) {
    this.conditions.splice(index, 1);
  }
}
